// Scena 3D dell'hero (WebGL con three.js): un oggetto nero e oro per ogni slide.
// Slide 1: Poke Ball - Slide 2: Mystery Box TCGBrugialdi - Slide 3: scudo "ordini protetti".
// Solo desktop: su telefono, con "riduci movimento" o se WebGL non c'e restano le illustrazioni.

const THREE_URL = "https://cdn.jsdelivr.net/npm/three@0.160.0/build/three.module.min.js";

const hero = document.querySelector("[data-hero-webgl]");
const mount = hero?.querySelector("[data-webgl-mount]");
const canRun =
  mount &&
  window.matchMedia("(min-width: 769px)").matches &&
  !window.matchMedia("(prefers-reduced-motion: reduce)").matches;

const fallback = () => {
  hero?.classList.remove("has-webgl");
  hero?.classList.add("webgl-failed");
};

if (canRun) init().catch(fallback);
else fallback();

async function init() {
  const THREE = await import(THREE_URL);

  const renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true, powerPreference: "high-performance" });
  renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
  renderer.outputColorSpace = THREE.SRGBColorSpace;
  renderer.toneMapping = THREE.ACESFilmicToneMapping;
  renderer.toneMappingExposure = 1.15;
  mount.append(renderer.domElement);

  const scene = new THREE.Scene();
  const camera = new THREE.PerspectiveCamera(30, 1, 0.1, 50);
  camera.position.set(0, 1.2, 11.5);
  camera.lookAt(0, 0, 0);

  // Ambiente per i riflessi del metallo: pannelli luminosi caldi attorno all'oggetto
  const pmrem = new THREE.PMREMGenerator(renderer);
  const envScene = new THREE.Scene();
  envScene.background = new THREE.Color(0x07060c);
  const panel = (color, power, w, h, x, y, z) => {
    const material = new THREE.MeshBasicMaterial({ color: new THREE.Color(color).multiplyScalar(power), side: THREE.DoubleSide });
    const mesh = new THREE.Mesh(new THREE.PlaneGeometry(w, h), material);
    mesh.position.set(x, y, z);
    mesh.lookAt(0, 0, 0);
    envScene.add(mesh);
  };
  panel(0xffffff, 4, 5, 2, 0, 5, 3);
  panel(0xffd36b, 3, 3, 4, -5, 1, 2);
  panel(0xfff1c8, 2, 3, 4, 5, 0, -1);
  panel(0xf5ce3b, 1.5, 6, 1, 0, -4, 2);
  panel(0x8a6420, 0.8, 4, 3, 0, 1, -5);
  scene.environment = pmrem.fromScene(envScene, 0.035).texture;

  scene.add(new THREE.AmbientLight(0xffffff, 0.25));
  const key = new THREE.DirectionalLight(0xfff1d6, 2.2);
  key.position.set(3, 4, 5);
  scene.add(key);
  const rim = new THREE.DirectionalLight(0xf5ce3b, 2.5);
  rim.position.set(-4, 2, -4);
  scene.add(rim);

  // Materiali nello stile del sito
  const gold = new THREE.MeshPhysicalMaterial({ color: 0xf2c23a, metalness: 1, roughness: 0.26, clearcoat: 0.6, clearcoatRoughness: 0.2 });
  const black = new THREE.MeshPhysicalMaterial({ color: 0x0e0d16, metalness: 0.45, roughness: 0.3, clearcoat: 1, clearcoatRoughness: 0.06 });
  const dark = new THREE.MeshStandardMaterial({ color: 0x050409, metalness: 0.3, roughness: 0.55 });
  const glow = new THREE.MeshStandardMaterial({ color: 0xfff1a8, emissive: 0xf5ce3b, emissiveIntensity: 1.6, metalness: 0.2, roughness: 0.3 });

  const glowTexture = (() => {
    const canvas = document.createElement("canvas");
    canvas.width = canvas.height = 256;
    const ctx = canvas.getContext("2d");
    const gradient = ctx.createRadialGradient(128, 128, 0, 128, 128, 128);
    gradient.addColorStop(0, "rgba(245,206,59,0.55)");
    gradient.addColorStop(0.45, "rgba(245,206,59,0.12)");
    gradient.addColorStop(1, "rgba(245,206,59,0)");
    ctx.fillStyle = gradient;
    ctx.fillRect(0, 0, 256, 256);
    const texture = new THREE.CanvasTexture(canvas);
    texture.colorSpace = THREE.SRGBColorSpace;
    return texture;
  })();

  // Alone dorato dietro e riflesso a terra
  const halo = new THREE.Mesh(
    new THREE.PlaneGeometry(6, 6),
    new THREE.MeshBasicMaterial({ map: glowTexture, transparent: true, depthWrite: false, blending: THREE.AdditiveBlending })
  );
  halo.position.z = -2;
  scene.add(halo);
  const floorGlow = new THREE.Mesh(
    new THREE.PlaneGeometry(3.6, 3.6),
    new THREE.MeshBasicMaterial({ map: glowTexture, transparent: true, depthWrite: false, blending: THREE.AdditiveBlending, opacity: 0.9 })
  );
  floorGlow.rotation.x = -Math.PI / 2;
  floorGlow.position.y = -1.55;
  scene.add(floorGlow);

  const stage = new THREE.Group();
  scene.add(stage);

  // ---------- Poke Ball nera e oro ----------
  const makeBall = () => {
    const group = new THREE.Group();
    const gap = 0.055;
    const top = new THREE.Mesh(new THREE.SphereGeometry(1, 96, 48, 0, Math.PI * 2, 0, Math.PI / 2 - gap), gold);
    const bottom = new THREE.Mesh(new THREE.SphereGeometry(1, 96, 48, 0, Math.PI * 2, Math.PI / 2 + gap, Math.PI / 2 - gap), black);
    const core = new THREE.Mesh(new THREE.SphereGeometry(0.97, 64, 32), dark);
    group.add(top, bottom, core);

    const ringRadius = Math.cos(gap);
    [Math.sin(gap), -Math.sin(gap)].forEach((y) => {
      const ring = new THREE.Mesh(new THREE.TorusGeometry(ringRadius, 0.012, 12, 128), gold);
      ring.rotation.x = Math.PI / 2;
      ring.position.y = y;
      group.add(ring);
    });

    const housing = new THREE.Mesh(new THREE.CylinderGeometry(0.34, 0.34, 0.2, 64), dark);
    housing.rotation.x = Math.PI / 2;
    housing.position.z = 0.9;
    const outerRing = new THREE.Mesh(new THREE.TorusGeometry(0.3, 0.035, 24, 64), gold);
    outerRing.position.z = 1.0;
    const button = new THREE.Mesh(new THREE.CylinderGeometry(0.22, 0.22, 0.08, 64), black);
    button.rotation.x = Math.PI / 2;
    button.position.z = 1.0;
    const buttonCore = new THREE.Mesh(new THREE.CylinderGeometry(0.12, 0.12, 0.06, 48), glow);
    buttonCore.rotation.x = Math.PI / 2;
    buttonCore.position.z = 1.04;
    group.add(housing, outerRing, button, buttonCore);
    group.rotation.x = 0.18;
    return group;
  };

  // ---------- Mystery Box TCGBrugialdi ----------
  const addEdges = (target, w, h, d, t, material) => {
    const xs = [-w / 2, w / 2];
    const ys = [-h / 2, h / 2];
    const zs = [-d / 2, d / 2];
    ys.forEach((y) => zs.forEach((z) => { const m = new THREE.Mesh(new THREE.BoxGeometry(w + t, t, t), material); m.position.set(0, y, z); target.add(m); }));
    xs.forEach((x) => zs.forEach((z) => { const m = new THREE.Mesh(new THREE.BoxGeometry(t, h + t, t), material); m.position.set(x, 0, z); target.add(m); }));
    xs.forEach((x) => ys.forEach((y) => { const m = new THREE.Mesh(new THREE.BoxGeometry(t, t, d + t), material); m.position.set(x, y, 0); target.add(m); }));
  };

  const questionTexture = (() => {
    const canvas = document.createElement("canvas");
    canvas.width = canvas.height = 256;
    const ctx = canvas.getContext("2d");
    const gradient = ctx.createLinearGradient(0, 0, 256, 256);
    gradient.addColorStop(0, "#fff1a8");
    gradient.addColorStop(0.5, "#f5ce3b");
    gradient.addColorStop(1, "#b07a10");
    ctx.fillStyle = gradient;
    ctx.fillRect(0, 0, 256, 256);
    ctx.fillStyle = "#181000";
    ctx.font = "900 170px 'Bebas Neue', Impact, sans-serif";
    ctx.textAlign = "center";
    ctx.textBaseline = "middle";
    ctx.fillText("?", 128, 140);
    const texture = new THREE.CanvasTexture(canvas);
    texture.colorSpace = THREE.SRGBColorSpace;
    return texture;
  })();

  const lidLight = new THREE.PointLight(0xf5ce3b, 0, 4, 1.5);
  const sparks = new THREE.Points(
    new THREE.BufferGeometry(),
    new THREE.PointsMaterial({ color: 0xffe58a, size: 0.05, transparent: true, opacity: 0, depthWrite: false, blending: THREE.AdditiveBlending })
  );
  const sparkCount = 70;
  const sparkData = new Float32Array(sparkCount * 3);
  const sparkSeed = Array.from({ length: sparkCount }, () => ({ x: (Math.random() - 0.5) * 1.1, z: (Math.random() - 0.5) * 1.1, speed: 0.4 + Math.random() * 0.8, offset: Math.random() }));
  sparks.geometry.setAttribute("position", new THREE.BufferAttribute(sparkData, 3));

  let lid;
  let innerGlow;
  const makeBox = () => {
    const group = new THREE.Group();
    const W = 1.5;
    const H = 1.2;
    const D = 1.5;
    const bodyY = -0.25;

    const body = new THREE.Group();
    body.position.y = bodyY;
    body.add(new THREE.Mesh(new THREE.BoxGeometry(W, H, D), black));
    addEdges(body, W, H, D, 0.05, gold);
    const sideBand = new THREE.Mesh(new THREE.BoxGeometry(W + 0.02, H, 0.22), gold);
    body.add(sideBand);

    const logoMaterial = new THREE.MeshStandardMaterial({ transparent: true, metalness: 0.1, roughness: 0.5, emissive: 0xffffff, emissiveIntensity: 0.12 });
    new THREE.TextureLoader().load(hero.dataset.logo, (texture) => {
      texture.colorSpace = THREE.SRGBColorSpace;
      texture.anisotropy = 8;
      logoMaterial.map = texture;
      logoMaterial.emissiveMap = texture;
      logoMaterial.needsUpdate = true;
    });
    [0, Math.PI].forEach((rotation) => {
      const plane = new THREE.Mesh(new THREE.PlaneGeometry(1.02, 0.83), logoMaterial);
      plane.rotation.y = rotation;
      plane.position.set(0, 0.04, Math.cos(rotation) * (D / 2 + 0.006));
      body.add(plane);
    });

    innerGlow = new THREE.Mesh(
      new THREE.PlaneGeometry(W - 0.06, D - 0.06),
      new THREE.MeshBasicMaterial({ color: 0xffd86b, transparent: true, opacity: 0, blending: THREE.AdditiveBlending, depthWrite: false })
    );
    innerGlow.rotation.x = -Math.PI / 2;
    innerGlow.position.y = H / 2 + 0.004;
    body.add(innerGlow);
    group.add(body);

    // Coperchio con incernieratura sul retro
    lid = new THREE.Group();
    lid.position.set(0, bodyY + H / 2, -D / 2 - 0.06);
    const lidInner = new THREE.Group();
    lidInner.position.set(0, 0.15, D / 2 + 0.06);
    const LW = W + 0.12;
    const LD = D + 0.12;
    lidInner.add(new THREE.Mesh(new THREE.BoxGeometry(LW, 0.3, LD), black));
    addEdges(lidInner, LW, 0.3, LD, 0.05, gold);
    lidInner.add(new THREE.Mesh(new THREE.BoxGeometry(0.24, 0.32, LD + 0.02), gold));
    lidInner.add(new THREE.Mesh(new THREE.BoxGeometry(LW + 0.02, 0.32, 0.24), gold));
    const medal = new THREE.Mesh(new THREE.CylinderGeometry(0.26, 0.26, 0.07, 64), [gold, new THREE.MeshStandardMaterial({ map: questionTexture, metalness: 0.6, roughness: 0.3 }), gold]);
    medal.position.y = 0.19;
    lidInner.add(medal);
    lid.add(lidInner);
    group.add(lid);

    lidLight.position.set(0, bodyY + H / 2 + 0.1, 0);
    group.add(lidLight);
    sparks.position.y = bodyY + H / 2;
    group.add(sparks);

    group.rotation.x = 0.22;
    return group;
  };

  // ---------- Scudo "ordini protetti" ----------
  const shieldShape = (k) => {
    const s = new THREE.Shape();
    s.moveTo(0, 1.1 * k);
    s.quadraticCurveTo(0.5 * k, 0.95 * k, 0.95 * k, 0.88 * k);
    s.lineTo(0.92 * k, 0.1 * k);
    s.quadraticCurveTo(0.85 * k, -0.7 * k, 0, -1.15 * k);
    s.quadraticCurveTo(-0.85 * k, -0.7 * k, -0.92 * k, 0.1 * k);
    s.lineTo(-0.95 * k, 0.88 * k);
    s.quadraticCurveTo(-0.5 * k, 0.95 * k, 0, 1.1 * k);
    return s;
  };
  const makeShield = () => {
    const group = new THREE.Group();
    const bodyGeometry = new THREE.ExtrudeGeometry(shieldShape(1), { depth: 0.26, bevelEnabled: true, bevelThickness: 0.08, bevelSize: 0.07, bevelSegments: 6, curveSegments: 40 });
    bodyGeometry.center();
    group.add(new THREE.Mesh(bodyGeometry, [black, gold]));

    const rimShape = shieldShape(0.86);
    rimShape.holes.push(new THREE.Path(shieldShape(0.79).getPoints(80)));
    const rimGeometry = new THREE.ExtrudeGeometry(rimShape, { depth: 0.04, bevelEnabled: false, curveSegments: 40 });
    const rim = new THREE.Mesh(rimGeometry, gold);
    rim.position.set(0, -0.025, 0.21);
    group.add(rim);

    const check = new THREE.Shape();
    check.moveTo(-0.46, 0.02);
    check.lineTo(-0.3, 0.18);
    check.lineTo(-0.1, -0.02);
    check.lineTo(0.34, 0.42);
    check.lineTo(0.5, 0.26);
    check.lineTo(-0.1, -0.34);
    check.lineTo(-0.46, 0.02);
    const checkGeometry = new THREE.ExtrudeGeometry(check, { depth: 0.08, bevelEnabled: true, bevelThickness: 0.03, bevelSize: 0.025, bevelSegments: 3 });
    const checkMesh = new THREE.Mesh(checkGeometry, [glow, gold]);
    checkMesh.position.set(0, -0.02, 0.2);
    group.add(checkMesh);
    return group;
  };

  // Ogni oggetto e un po' inclinato, come le grafiche originali dell'hero (Poke Ball -12, box 8, scudo 6 gradi)
  const tilts = [-12, 8, 6].map((deg) => {
    const tilt = new THREE.Group();
    tilt.rotation.z = THREE.MathUtils.degToRad(deg);
    stage.add(tilt);
    return tilt;
  });
  const baseScale = [1.4, 1.2, 1.2];
  const objects = [makeBall(), makeBox(), makeShield()].map((object, index) => {
    object.userData.base = baseScale[index];
    object.userData.k = index === Number(hero.dataset.slide || 0) ? 1 : 0;
    object.visible = object.userData.k > 0;
    tilts[index].add(object);
    return object;
  });

  let target = Number(hero.dataset.slide || 0);
  hero.addEventListener("hero:slide", (event) => { target = event.detail; });

  // Il puntatore inclina la scena
  const pointer = { x: 0, y: 0 };
  hero.addEventListener("pointermove", (event) => {
    const rect = hero.getBoundingClientRect();
    pointer.x = (event.clientX - rect.left) / rect.width - 0.5;
    pointer.y = (event.clientY - rect.top) / rect.height - 0.5;
  });
  hero.addEventListener("pointerleave", () => { pointer.x = 0; pointer.y = 0; });

  const resize = () => {
    const { width, height } = mount.getBoundingClientRect();
    if (!width || !height) return;
    renderer.setSize(width, height, false);
    camera.aspect = width / height;
    camera.updateProjectionMatrix();
  };
  new ResizeObserver(resize).observe(mount);
  resize();

  const easeOutBack = (x) => 1 + 2.2 * Math.pow(x - 1, 3) + 1.2 * Math.pow(x - 1, 2);
  const clock = new THREE.Clock();
  let running = true;
  let frame = 0;

  const tick = () => {
    frame = running ? requestAnimationFrame(tick) : 0;
    const dt = Math.min(clock.getDelta(), 0.05);
    const t = clock.elapsedTime;

    stage.rotation.y += (pointer.x * 0.6 - stage.rotation.y) * Math.min(1, dt * 4);
    stage.rotation.x += (pointer.y * 0.35 - stage.rotation.x) * Math.min(1, dt * 4);
    stage.position.y = Math.sin(t * 1.3) * 0.07;

    objects.forEach((object, index) => {
      const goal = index === target ? 1 : 0;
      object.userData.k += (goal - object.userData.k) * Math.min(1, dt * 5);
      const k = object.userData.k;
      object.visible = k > 0.002;
      if (!object.visible) return;
      object.scale.setScalar(object.userData.base * Math.max(0.001, goal ? easeOutBack(k) : k));
      object.position.y = (1 - k) * (goal ? -0.6 : 0.6);
    });

    // La Poke Ball oscilla attorno al davanti: il bottone bianco resta sempre visibile
    objects[0].rotation.y = Math.sin(t * 0.6) * 0.5 + (1 - objects[0].userData.k) * Math.PI * 2;
    objects[1].rotation.y = Math.sin(t * 0.45) * 0.6 + 0.5 + (1 - objects[1].userData.k) * 3;
    objects[2].rotation.y = Math.sin(t * 0.7) * 0.45 + (1 - objects[2].userData.k) * 3;

    // Il coperchio della Mystery Box si apre e lascia uscire la luce
    const open = Math.pow(Math.max(0, Math.sin(t * 0.9)), 3);
    lid.rotation.x = -open * 0.55;
    lidLight.intensity = open * 8;
    innerGlow.material.opacity = open * 0.85;
    sparks.material.opacity = open;
    sparkSeed.forEach((spark, i) => {
      const life = (t * spark.speed * 0.5 + spark.offset) % 1;
      sparkData[i * 3] = spark.x * (1 + life * 0.6);
      sparkData[i * 3 + 1] = life * 1.8;
      sparkData[i * 3 + 2] = spark.z * (1 + life * 0.6);
    });
    sparks.geometry.attributes.position.needsUpdate = true;

    halo.material.opacity = 0.85 + Math.sin(t * 1.6) * 0.15;
    renderer.render(scene, camera);
  };

  const setRunning = (value) => {
    if (value === running) return;
    running = value;
    if (running) {
      clock.getDelta();
      frame = requestAnimationFrame(tick);
    } else {
      cancelAnimationFrame(frame);
    }
  };
  new IntersectionObserver(([entry]) => setRunning(entry.isIntersecting && !document.hidden)).observe(hero);
  document.addEventListener("visibilitychange", () => setRunning(!document.hidden));

  tick();
  hero.classList.add("has-webgl");
}
